import { Clock, Tag, ShieldCheck, LogIn, CreditCard } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import BrandLogo from "@/components/BrandLogo";

const INSTITUTE_NAME = import.meta.env.VITE_INSTITUTE_NAME || "Rise Institute";

export default function PricingCard({ course, onCheckout, loading }) {
  return (
    <Card className="border-border rounded-3xl p-8 shadow-lg flex flex-col items-center text-center sticky top-28">
      <div className="w-16 h-16 bg-muted/40 rounded-2xl border border-border flex items-center justify-center mb-6 shadow-sm p-2">
        <BrandLogo alt="Institute logo" className="w-full h-full object-contain" />
      </div>

      <h3 className="text-muted-foreground font-semibold uppercase tracking-widest text-xs mb-2">
        One-Time Enrollment
      </h3>

      <div className="flex items-end justify-center gap-2 mb-1">
        <span className="text-5xl font-extrabold text-foreground tracking-tight">
          {course.discountPrice}
        </span>
      </div>

      <div className="flex items-center gap-2 text-muted-foreground font-medium mb-8">
        <span className="line-through decoration-border">{course.originalPrice}</span>
        <span className="text-success text-sm font-bold bg-success/10 px-2 py-0.5 rounded-md">
          Save {course.savings}
        </span>
      </div>

      {/* Info Cards */}
      <div className="w-full space-y-4 mb-8 text-left">
        <div className="flex items-center gap-3 p-4 rounded-xl bg-muted/40 border border-border">
          <Clock className="w-5 h-5 text-primary shrink-0" />
          <div>
            <div className="text-xs text-muted-foreground font-medium">Program Duration</div>
            <div className="font-bold text-foreground text-sm">{course.duration}</div>
          </div>
        </div>
        <div className="flex items-center gap-3 p-4 rounded-xl bg-muted/40 border border-border">
          <Tag className="w-5 h-5 text-primary shrink-0" />
          <div>
            <div className="text-xs text-muted-foreground font-medium">Access</div>
            <div className="font-bold text-foreground text-sm">Full Course Material</div>
          </div>
        </div>
        <div className="flex items-center gap-3 p-4 rounded-xl bg-muted/40 border border-border">
          <ShieldCheck className="w-5 h-5 text-primary shrink-0" />
          <div>
            <div className="text-xs text-muted-foreground font-medium">Secure Payment</div>
            <div className="font-bold text-foreground text-sm">Razorpay Checkout</div>
          </div>
        </div>
      </div>

      {/* Enrollment Steps */}
      <div className="w-full mb-8 rounded-xl border border-border bg-muted/30 p-4 text-left space-y-3">
        <p className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">
          How enrollment works
        </p>
        <div className="flex items-start gap-3">
          <LogIn className="w-4 h-4 text-primary shrink-0 mt-0.5" />
          <p className="text-sm text-foreground">Step 1: Sign in as a learner.</p>
        </div>
        <div className="flex items-start gap-3">
          <Tag className="w-4 h-4 text-primary shrink-0 mt-0.5" />
          <p className="text-sm text-foreground">
            Step 2: Review this course inside your learner catalog.
          </p>
        </div>
        <div className="flex items-start gap-3">
          <CreditCard className="w-4 h-4 text-primary shrink-0 mt-0.5" />
          <p className="text-sm text-foreground">
            Step 3: Pay via the same secure Razorpay flow.
          </p>
        </div>
      </div>

      <Button onClick={onCheckout} disabled={loading} className="w-full h-12 text-base font-bold rounded-xl shadow-lg">
        {loading ? "Processing..." : "Continue to Secure Checkout"}
      </Button>

      <p className="mt-4 text-xs text-muted-foreground font-medium">
        {INSTITUTE_NAME}
      </p>
    </Card>
  );
}
